import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ALERT_POPUP_STATUS } from '../constants/alert-popup-status.enum';
import { TuwaiqConfig } from '../constants/tuwaiq.config';
import { AttachmentFile } from '../models/attachment-file.model';
import { Attachment } from '../models/attachment.model';
import { Comment } from '../models/comment.model';
import { FilterDetails } from '../models/filter-details.model';
import { RequestDetailsResponse } from '../models/request-details-response.modal';

@Injectable({
    providedIn: 'root'
})
export class RequestViewService {
    onOpenDialogClick = new Subject<string>();
    onReloadRequests = new Subject<boolean>();
    onCloseDialog = new Subject<boolean>();
    onRequestAssigned = new Subject<boolean>();
    showTableLoader = new Subject<boolean>();
    filterRequestList = new Subject<FilterDetails[]>();
    fetchNextPage = new Subject<number>();
    updateCount = new Subject<boolean>();
    passReturnedRequestDetails = new Subject<Comment>();
    showLoaderOverlay = new Subject<boolean>();
    scrollToTop = new Subject<boolean>();
    removeAttachment = new Subject<AttachmentFile | Attachment>();
    selectedRequests: number[] = [];
    requestDetails: RequestDetailsResponse;
    updateAlertPopupStatus = new Subject<{
        status: ALERT_POPUP_STATUS;
        message: string;
    }>();
    alertPopupConfirm = new Subject<boolean>();
    alertPopupReviwedConfirm = new Subject<boolean>();

    clearAttachments = new Subject<boolean>();
    dateRangeChanged = new Subject<boolean>();
    onDataEdit = new Subject<any>();
    onFolderDataEdit = new Subject<any>();
    onFileDataEdit = new Subject<any>();
    onSharedDataEdit = new Subject<any>();
    onDataEditStatus = new Subject<any>();
    deleteSelectedUser = new Subject<any>();
    isActionForRequestList = new Subject<boolean>();
    private currentFilters: { [key: string]: any } = {};

    constructor() {
          this.filterRequestList.subscribe(filters => {
            filters.forEach(filter => {
                if (filter.removeFilter) {
                    delete this.currentFilters[filter.key];
                } else {
                    this.currentFilters[filter.key] = filter.value;
                }
            });
        });
    }

    storeSelectedRequests(selectedRequests: number[]) {
        this.selectedRequests = selectedRequests;
    }

    getSelectedRequests() {
        return this.selectedRequests;
    }

    storeRequestDetails(requestDetails: RequestDetailsResponse) {
        this.requestDetails = requestDetails;
    }

    getRequestDetails(): RequestDetailsResponse {
        return this.requestDetails;
    }

    getCreateRequestBody(attachmentList, description, detailsList, serviceId) {
        return {
            [TuwaiqConfig.CREATE_REQUEST_KEYS.ATTACHMENTS]: this.handleAttachmentObject(attachmentList),
            [TuwaiqConfig.CREATE_REQUEST_KEYS.DESCRIPTION]: description,
            [TuwaiqConfig.CREATE_REQUEST_KEYS.DETAILS]: { data: detailsList },
            [TuwaiqConfig.CREATE_REQUEST_KEYS.SERVICE_ID]: serviceId
        };
    }

    handleAttachmentObject(attachmentList) {
        return attachmentList.map(attachment => ({
            checksum: TuwaiqConfig.ATTACHMENT_CHECKSUM,
            'content-type': attachment.type,
            key: attachment.key,
            name: attachment.name,
            size: attachment.size
        }));
    }

    getCurrentFilters(): { [key: string]: any } {
        return { ...this.currentFilters };
    }

    clearFilters() {
        this.currentFilters = {};
    }
}
